import { ApolloClient, InMemoryCache, createHttpLink, from, split } from '@apollo/client/core';
import { onError } from '@apollo/client/link/error';
import { GraphQLWsLink } from '@apollo/client/link/subscriptions';
import { createClient } from 'graphql-ws';
import { getMainDefinition } from '@apollo/client/utilities';

import { setContext } from '@apollo/client/link/context';
import router from '@/router';

const customFetch = async (uri, options) => {
  const response = await fetch(uri, options);

  // Log all headers
  console.log('Response Status:', response.status);
  console.log('Response Status Text:', response.statusText);

  // Print all headers
  console.log('--- All Response Headers ---');
  response.headers.forEach((value, key) => {
    console.log(`${key}: ${value}`);
  });

  // Check for specific headers you're interested in
  const notAuthHeader = response.headers.get('NOT_AUTHENTICATION');
  if (notAuthHeader) {
    console.warn('NOT_AUTHENTICATION detected in response header!', notAuthHeader);
    // You could trigger logout here if needed
    // logoutAndRedirect();
  }

  return response;
};

/* ------------------------------------------------------------------ */
/* 1. Plain HTTP link (always last in the chain)                       */
/* ------------------------------------------------------------------ */
const httpLink = createHttpLink({
  uri: `${process.env.VUE_APP_API_URL}/graphql`,  // Vite syntax; use process.env.* with Vue-CLI
});


/* ------------------------------------------------------------------ */
/* 3. Error-handling link                                             */
/* ------------------------------------------------------------------ */
const errorLink = onError(( {networkError} ) => {
  console.log('networkError', networkError);
  if (networkError && 'statusCode' in networkError) {
    const status = networkError.statusCode;
    if (status === 401) {
      // Not authenticated
      console.log('User is not authenticated!');
      logoutAndRedirect()
      // e.g., clear storage and redirect to login
    }
  }
});

function logoutAndRedirect() {
  localStorage.clear();
  apolloClient.clearStore().catch(err => {
    console.error('Error clearing Apollo store:', err);
  });
  router.replace('/login');
}

/* ------------------------------------------------------------------ */
/* 2. WebSocket link for subscriptions                                */
/* ------------------------------------------------------------------ */
const wsLink = new GraphQLWsLink(createClient({
  url: `${process.env.VUE_APP_API_URL?.replace(/^http/, 'ws')}/graphql`,
  connectionParams: () => ({
    Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
  }),
  retryAttempts: Infinity,
  retryTimeout: (attempt) => Math.min(attempt * 1000, 10000),
  keepAlive: 15000,
  on: {
    connected: () => console.log('WebSocket connected'),
    error: (error) => console.error('WebSocket error:', error),
    closed: () => console.log('WebSocket closed'),
  },
}));

/* ------------------------------------------------------------------ */
/* 4. Split link for queries/mutations vs subscriptions              */
/* ------------------------------------------------------------------ */
const splitLink = split(
  ({ query }) => {
    const definition = getMainDefinition(query);
    return (
      definition.kind === 'OperationDefinition' &&
      definition.operation === 'subscription'
    );
  },
  wsLink,
  from([errorLink, httpLink])
);

/* ------------------------------------------------------------------ */
/* 5. Bring the links together -- NOTE the order                      */
/*    errorLink ➔ authLink ➔ splitLink                                */
/* ------------------------------------------------------------------ */
const link = splitLink;

/* ------------------------------------------------------------------ */
/* 6. Finally create and export the client                            */
/* ------------------------------------------------------------------ */
export const apolloClient = new ApolloClient({
  link,
  cache: new InMemoryCache({ addTypename: false }),
  defaultOptions: {
    watchQuery: { fetchPolicy: 'no-cache', errorPolicy: 'ignore' },
    query: { fetchPolicy: 'no-cache', errorPolicy: 'all' },
  },
});

export default apolloClient;
